import React, { useState } from "react";

export default function RequestAccess({ onClose }) {
  const [formData, setFormData] = useState({ name: "", email: "", contact: "" });
  const [loading, setLoading] = useState(false);

  const driveLink = "https://drive.google.com/file/d/1LAUadHcP926BigAuTl5hPG5tx3R6GFB6/view?usp=sharing"; 
  const web3FormsKey = "8575db0a-d712-45bb-a231-82873de4c9bd"; 

  const sendRequest = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formPayload = new FormData();
    formPayload.append("access_key", web3FormsKey);
    formPayload.append("name", formData.name);
    formPayload.append("email", formData.email);
    formPayload.append("contact", formData.contact);
    formPayload.append("subject", "Drive Access Request");
    formPayload.append(
      "message",
      `Name: ${formData.name}\nEmail: ${formData.email}\nContact: ${formData.contact}`
    );

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formPayload,
      });
      const data = await res.json();

      if (data.success) {
        alert("✅ Thank you for your purchase! Course access will be shared to your email within 24 hours!");
        window.location.href = driveLink;
      } else {
        alert("❌ Failed to send request.");
      }
    } catch (error) {
      console.error(error);
      alert("❌ Error sending request.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button style={styles.closeBtn} onClick={onClose}>✖</button>
        <h2>Request Drive Access</h2>
        <form onSubmit={sendRequest}>
          <input
            type="text"
            placeholder="Enter your Full name"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
            style={styles.input}
          />
          <input
            type="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            required
            style={styles.input}
          />
          <input
            type="tel"
            placeholder="Enter your WhatsApp number"
            value={formData.contact}
            onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
            required
            style={styles.input}
          />
          <button type="submit" disabled={loading} style={styles.submitBtn}>
            {loading ? "Sending..." : "Start Now !"}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex", alignItems: "center", justifyContent: "center",
    zIndex: 10000,
  },
  modal: {
    backgroundColor: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "300px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: "10px", right: "10px",
    background: "none",
    border: "none",
    fontSize: "18px",
    cursor: "pointer",
  },
  input: {
    padding: "10px",
    width: "93%",
    marginBottom: "10px",
    borderRadius: "5px",
    border: "1px solid #ccc",
  },
  submitBtn: {
    padding: "10px 20px",
    //backgroundColor: "blue",
    color: "#000",
    border: "none",
    fontWeight: "bold",
    borderRadius: "5px",
    cursor: "pointer",
    width: "100%",
    background: 'linear-gradient(to right, #f8b500, #e68a00)',
  },
};
